function median(values: number[]): number {
	const sorted = [...values].sort((a, b) => a - b);
	const mid = Math.floor(sorted.length / 2);
	return sorted.length % 2 === 0
		? (sorted[mid - 1]! + sorted[mid]!) / 2
		: sorted[mid]!;
}

/**
 * Discard outlier prices (far from median), then return arithmetic mean of survivors.
 * Falls back to median if every sample is filtered out.
 */
export function aggregatePrices(
	samples: number[],
	maxDeviation = 0.15,
): number | null {
	const valid = samples.filter((p) => Number.isFinite(p) && p > 0);
	if (valid.length === 0) return null;

	const med = median(valid);
	if (med <= 0) return null;

	const kept = valid.filter(
		(p) => Math.abs(p - med) / med <= maxDeviation,
	);
	const pool = kept.length > 0 ? kept : valid;
	return pool.reduce((sum, p) => sum + p, 0) / pool.length;
}
